<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 15:58:03
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-16 14:21:01
 * @FilePath: /goldenSalesMobile/src/views/UsersAccountCenter/index.vue
 * @Description: 消费者个人中心
-->
<template>
  <div class='page-container'>
    <!-- <nav-bar title="个人中心" /> -->

    <router-link :to="{ name: 'UserInfo' }">
      <div class="main-box">
        <img
          class="avatar"
          :src=" userInfo.HeadImageUrl ? userInfo.HeadImageUrl : require('../../assets/account_image/avatar.png')"
          alt=""
        >
        <p class="user-name">{{ userInfo.UserName	 }}</p>
        <p class="user-phone">{{ userInfo.Phone }}</p>
      </div>
    </router-link>

    <ul class="nav-list">
      <router-link
        v-for="(item, index) in navList"
        :key="index"
        tag="li"
        :to="{ name: item.link }"
      >
        <span>
          <svg-icon :iconClass="item.icon" />
          {{ item.name }}
        </span>
        <i class="arrow right" />
      </router-link>
    </ul>

    <div class="service-tel">
      <span>
        <svg-icon iconClass="service-tel" />
        客服电话
      </span>
      <span><a :href="'tel:' + serviceTel ">{{ serviceTel }}</a></span>
    </div>

    <div
      class="logout-btn"
      @click="onLogout"
    >
      <span>退出登录</span>
    </div>
    <g-copy-right />
  </div>
</template>

<script>
import { getConsumerInfo, logOut } from '@/api/user'
import { removeToken } from '@/utils/auth'
export default {
  data() {
    return {
      serviceTel: '010-2345-3322',
      userInfo: {},
      navList: [
        {
          name: '退款订单',
          link: 'RefundOrderList',
          icon: 'refund_order'
        },
        {
          name: '优惠券',
          link: 'CouponList',
          icon: 'refund_order'
        }
      ],
    }
  },

  created() {
    this.init()
  },

  methods: {
    // 获取消费者信息
    init() {
      getConsumerInfo()
        .then(res => {
          this.userInfo = res
        })
    },

    // 退出登录
    onLogout() {
      logOut()
        .then(res => {
          if (res) {
            removeToken()
            $pub.clearS('saleToken');
            // this.$router.go(0);
            this.$router.replace({
              name: 'Login'
            })
          }
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.page-container {
  .main-box {
    @include flex-box(flex-start, center);
    flex-direction: column;
    margin-bottom: 22px;
    padding-bottom: 40px;
    overflow: hidden;
    background: $blockBgColor;

    .avatar {
      display: block;
      width: 188px;
      height: 188px;
      margin: 24px auto 0;
    }

    .user-name {
      margin-bottom: 12px;
      text-align: center;
      line-height: 56px;
      font-size: 40px;
      font-weight: 500;
      color: $secondFontColor;
    }

    .user-phone {
      text-align: center;
      line-height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: $baseFontColor;
    }
  }

  .nav-list {
    width: 100%;
    background: #fff;

    > li {
      @include border-box(0 36px);
      @include flex-box(space-between);
      width: 100%;
      height: 100px;
      border-bottom: 1px solid #f7f7f7;

      > span {
        line-height: 44px;
        font-size: 32px;
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .service-tel {
    @include flex-box(space-between, center);
    @include border-box(40px);
    width: 100%;
    height: 100px;
    background: $blockBgColor;
    margin-bottom: 22px;

    > span:first-child {
      line-height: 40px;
      font-size: 28px;
      color: $baseFontColor;
    }

    > span:last-child {
      line-height: 42px;
      font-size: 30px;
      font-weight: 500;
      color: $secondFontColor;

      > a {
        color: $secondFontColor;
      }
    }
  }

  .logout-btn {
    @include flex-box(center);
    margin-top: 10px;
    height: 104px;
    background: #fff;

    > span {
      line-height: 44px;
      font-size: 32px;
      font-weight: 500;
      color: $secondFontColor;
    }
  }
}
.arrow {
  border: solid black;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 6px;

  &.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  &.left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  &.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  &.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}
</style>

